import {generatePath} from "react-router-dom";

import {AppRoute} from "constants/routes";

export function getHomePathByCity(city: string) {
    return `/${generatePath(AppRoute.CITY_PREFIX, {city})}`;
}
